import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY,ErrorDCR } from '@ddt-web/config';
import { UrlQueryParamService } from '@ddt-web/url';

import { ErrorObject, PopupDialogAction, PopupDialogObject, PopupDialogOptions } from '../models';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable({
	providedIn: 'root'
})
export class ExceedPortfolioLimitErrorHandlerService extends AbstractErrorHandlerService {

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService,
		protected urlService: UrlQueryParamService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error: any): void {
		if ((error instanceof ErrorObject && error.configName === ERROR_CODES.MAX_PORTFOLIOS_LIMIT_ERROR)) {
			this.errorSeverity = ERROR_SEVERITY.ERROR;
			this.trackErrorMessage = 'exceedPortfolioLimitError';
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

			const actions = [
				PopupDialogAction.create({
					label: this.contentService.get('ERROR_CONTINUE_LABEL', ErrorDCR.ERROR_CONTINUE_LABEL),
					type: 'max_portfolios_limit',
					reload: true,
					params: Array.from(new Set(error.responseJson.portfolioIds as string[])).slice(0, error.responseJson.limit),
					url: error.responseJson.url
				})
			];

			const failedMessage = PopupDialogObject.create({
				success: false,
				title: this.contentService.get('MAX_PORTFOLIOS_LIMIT_ERROR_TITLE', 'Selected portfolios has crossed the selection limit'),
				description: this.contentService.get('MAX_PORTFOLIOS_LIMIT_ERROR_DESCRIPTION', 'Continue with the allowed number of portfolios from beginning.'),
				actions: actions
			} as PopupDialogOptions);
			this.errorPopupService.openResponseMessageDialog(failedMessage);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
